import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  developers: [],
  developerData: {},
  formData: {
    name: "",
    phone: "",
    email: "",
    addresses: [],
    contacts: [],
  },
  loading: false,
  error: "",
  success: "",
  isEditing: false,
};

const DeveloperSlice = createSlice({
  name: "Developer",
  initialState,
  reducers: {
    setDevelopers(state, action) {
      state.developers = action.payload;
    },

    setDeveloperData(state, action) {
      state.developerData = action.payload;
    },

    setFormData(state, action) {
      state.formData = { ...state.formData, ...action.payload };
    },

    resetFormData(state) {
      state.formData = initialState.formData;
    },

    clearDeveloperData(state) {
      state.developerData = {};
    },

    setLoading(state, action) {
      state.loading = action.payload;
    },

    setIsEditing(state, action) {
      state.isEditing = action.payload;
    },

    developerError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },

    developerSuccess(state, action) {
      state.success = action.payload;
      state.loading = false;
    },

    clearMessages(state) {
      state.error = "";
      state.success = "";
    },
  },
});

export const {
  setDevelopers,
  setDeveloperData,
  setFormData,
  resetFormData,
  clearDeveloperData,
  setLoading,
  setIsEditing,
  developerError,
  developerSuccess,
  clearMessages,
} = DeveloperSlice.actions;

export default DeveloperSlice.reducer;
